import React, { Component } from "react";
import "./NodeModal.css";
import "./UUIDModal.css";
import InfoIcon from './InfoIcon'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
} from "reactstrap";

export default class UUIDModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied:false,
    };
  }
  render() {
    const { title, toggle, toggleName, uuid, info } = this.props;

    return (
      <Modal
        modalClassName="Modal"
        isOpen={true}
        toggle={function () {
          return toggle(toggleName);
        }}
      >
        <ModalHeader>
          {title}
          <InfoIcon position="right" infoText={info}/>
          <button
            className="exit_close_button"
            onClick={function () {
              return toggle(toggleName);
            }}
          >
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Input type="text" name="uuid" defaultValue={uuid} id="uuid" readOnly/>
            </FormGroup>
          </Form>
          <div className="uuid_footer">
          <button
            className="save_button"
            color="success"
            onClick={() => {
              var copyText = document.getElementById("uuid");

              /* Select the text field */
              copyText.select();
              copyText.setSelectionRange(0, 99999); /* For mobile devices */

              /* Copy the text inside the text field */
              document.execCommand("copy");

              this.setState({copied: true})
            }}
          >
            Copy to clipboard
          </button>
          {this.state.copied ? 
          <div className="copied_text">
            Copied!
          </div> : null}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
